export default {
  buyer_create_question: {
    management: {
      create_new: 'Create new survey',
      create_new_start: 'Start from scratch',
      create_new_start_description: 'You can freely add questions one by one to create a custom survey',
      create_by_template: 'Create from template',
      create_by_template_description: 'Create surveys efficiently using commonly used templates',
      created_survey_list_title: 'Created surveys',
      survey: 'Survey',
      number_of_survey: 'Number of issued surveys',
      supplier: '@:common.supplier',
    },
    list: {
      number_of_answered_company: '@:evaluation_dashboard.answer_transition.companies_submitted',
      no_survey: 'There are no created surveys',
      number_of_suppliers: '@:list_table_filter.number_of_suppliers',
    },
    flow: {
      title: 'Survey creation flow',
      basic: 'Basic settings',
      basic_description: 'Set the survey title, answer deadline, language, and other settings',
      create_description: 'Add questions and configure answer types, translations, and branching',
      confirm_description: 'Review the input and translations and perform a final check before investigating',
      issue_url: 'Issue URL',
      issue_url_description: 'Issue a answer URL and share it with target companies',
    },
    language: 'Language',
    language_description: 'You can select multiple languages from 11 available options The survey will be displayed to respondents in the language based on their system settings',
    base_language: 'Base language',
    add_language: 'Languages to add for translation',
    caution: 'Cannot be changed after the survey has started',
    survey_title: 'Title',
    survey_title_description: 'Enter the name of the survey It will be shown to respondents',
    answer_deadline_description: 'Set the response deadline It will be shown to respondents',
    number_of_target_company: 'Number of target companies',
    number_of_target_company_description_1: 'Enter the number of companies you plan to request answers in this survey',
    number_of_target_company_description_2: 'The dashboard displays registration and answer rates based on the number of companies covered, making it easier to track progress.',
    btn: {
      save_and_exit: 'Save and exit',
      preview: 'Preview',
      back_edit: 'Return to edit',
      start_survey: 'Start survey',
      copy_url: 'Copy URL',
    },
    create: {
      back_settings: 'Edit basic settings',
      bundle: 'Section',
      question: '@:list_table_filter.csv_modal_answer_heading_question',
      structure: 'Structure',
      error_alert: 'There are items to be fixed',
      question_text: 'Question text',
      required_type: 'Required or optional answer',
      guide: 'Guide',
      answer_type: 'Answer type',
      single_select: 'Single select',
      multiple_selects: 'Multiple selects',
      text: 'Text input',
      number: 'Number',
      amount: 'Amount',
      selects: 'Selects',
      selects_add: 'Additional input',
      selects_branch: 'Branching',
      selects_branching_question: 'Branching question',
      selects_add_description: 'Additional input on selection',
      remarks: 'Remarks field',
      attach: 'File attachment',
      copy_question: 'Copy question',
      delete_question: 'Delete question',
      label: 'Label',
      answer_field: 'Answer field',
      caution_conditional_required: 'Cannot be modified due to branching settings.',
      error_category_without_bundle: 'Each category must contain at least one section.',
      error_bundle_without_question: 'Each section must contain at least one question.',
    },
    start_survey_modal: {
      title: 'Start the survey',
      description_1: 'Are you sure you want to complete the edits and start the survey?',
      description_2: 'You will not be able to make changes to the survey after registration',
    },
    registration_url: 'URL for answers',
    registration_url_description_1: 'A URL for answers has been issued',
    registration_url_description_2: 'Please direct target companies to this URL when requesting answers to the survey.',
    registration_default_language: 'Default display language',
    url_copied: 'URL copied',
    status: {
      draft: 'Draft',
      investigating: 'Investigating',
    }
  },
};
